<script>
import { useToast } from "vue-toastification";

import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getAuthorizationsToMod, unlockMod, deleteAuthorization, saveAuthorization } from '@/services/serviceMod';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'ModAuths',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,LoadingButton
		,Alert
	},
	props: {'modId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["modId","changeRecord"],
	data() {
		return {
			prefix:'',
			
			params:[],
			metaData: [],
			
			isLoading:true,
			isSending:false,
			
			mod:[],
			newAuthorization:'',
			
			authorizations:[]
			
		}
	},
	
	mounted:function(){
	
	},
	
	methods: {
		// load data form
		loadDefaultValues:function(){
			
			this.isLoading=true
			
			getAuthorizationsToMod({modId:this.modId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.authorizations = response.authorizations;
					this.mod = response.mod;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});		
		},
	
		onSave:function(){
			this.isSending=true;
			saveAuthorization({newAuthorization:this.newAuthorization,modId:this.modId}).then(response => {
				if(!response.statusText){
					this.isSending=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.loadDefaultValues();
						this.newAuthorization='';
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isSending=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});		

		},
		
		onDelete:function(authorizationId){
			
			if(authorizationId){
				this.isSending=true;
				deleteAuthorization({authorizationId:authorizationId}).then(response => {
					if(!response.statusText){
						this.isSending=false
						if(response.resCode==1){
							this.toast.success(this.$t('msgCore.dataWasDeleted'));
							this.loadDefaultValues();
						}else if(response.resCode==0){
							this.toast.warning(this.$t('msgCore.dataCantBeDeleted'));
						}else if(response.resCode==2){
							this.toast.warning(this.$t('msgCore.dataWasNotDeleted'));
						}else if(response.resCode==3){
							this.toast.error(this.$t('msgCore.accessDenied'));
						}
					}else{
						this.isSending=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
				
				
			}
			
		},
		
		
		
		onClose:function(){
			if(this.modId!='null'){
				unlockMod({modId:this.modId}).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},
		
		
	},
	
	watch: {
		modId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
	
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-lg">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCore.Mod') }} <b><span>{{ mod.title }}</span></b></h6>
					</div>
			
					<div v-if="metaData.modulAccess && (auth.modsChangeAuths)" class="modal-body">
					
						<div class="row">
							<div class="col-12">
								<p>Oprávnenia</p>
							</div>	
						</div>	
						
						<div class="row">
							<div class="col-12">
								<div class="input-group col-md-4 col-12">
									<input type="text"  :disabled="(!auth.modsAddAuths)" class="form-control form-control-sm" v-model='newAuthorization' :placeholder="$t('msgCore.Title')">
								
									<LoadingButton :isDisabled="(!auth.modsAddAuths || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnAdd'" color="warning"></LoadingButton>
								</div>
							</div>	
						</div>
						
						<div class="row">
							<div class="col-12">
								<table class="table table-sm">
									<tr v-for="(authorization) in authorizations" :key="authorization">
										<td>{{authorization.id}}</td>
										<td>{{authorization.name}}</td>
										<td>
											<div class="btn-group">
												<LoadingButton :isDisabled="((!auth.modsDeleteAuths || !authorization.isBlocked) || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onDelete(authorization.id)" :label="'msgCore.btnDelete'" color="danger"></LoadingButton>
											</div>
										</td>
									</tr>
								</table>
							</div>
						</div>
						
					</div>
					
					<div v-else class="modal-body">
						<div class="row">
							<div class="col-12 mt-3">
								<Alert type="warning" :label="$t('msgCore.accessDenied')" />
							</div>
						</div>
					</div>
					
					<div class="modal-footer">
					
						<div class="btn-group">
							<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
						</div>	
						
					</div>
				
					
				
				</div>

			</div>
			
		</div>
	</div>
</template>


